import ConditionReportSearchModel from "@/modules/condition-reports/ConditionReportSearch.model";
import ConditionReportsService from "@/modules/condition-reports/ConditionReportsService";
import {store} from "@/plugins/vuex";
import {
  CONDITION_REPORTS_TABLE_NAME,
  SOURCE_CONDITION_REPORTS_TABLE,
} from "@/modules/constants";
import _ from "lodash";
import i18n from "@/shared/i18n";

let getDefaultTableData = () => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new ConditionReportSearchModel(),
    sale: null,
    extraFilters: {}
  }
};

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      source: null
    },
    statuses: [
      {key: i18n.t('Draft'), value: 'draft'},
      {key: i18n.t('Released'), value: 'released'}
    ],
    tableData: {
      inventory: getDefaultTableData(),
      send_modal: getDefaultTableData(),
    }
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: CONDITION_REPORTS_TABLE_NAME
      });

      if (payload) {
        data = {...payload.pagination, search: payload.search, ordering: payload.ordering,};
      } else {
        data = {...currentTableData.pagination, search: currentTableData.search, ordering: ordering}
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {...data, ...searchModelData}
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }


      data.expand = `created_by,released_by`;
      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await ConditionReportsService.getConditionReports(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new ConditionReportSearchModel({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    updateExtraFilters({commit}, extraFilters) {
      commit('updateExtraFilters', extraFilters);
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const sale = state.tableData[state.tableSource].sale;
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      state.tableData[state.tableSource].sale = sale;
      dispatch('getTableData');
    },
    async showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    async hideModal({commit}) {
      commit('hideModal');
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async createConditionReport({dispatch, state}, payload) {
      let response = await ConditionReportsService.createConditionReport(payload, ''); // TODO Adjust expand
      if (response.success) {
        if (state.modal.source === SOURCE_CONDITION_REPORTS_TABLE) {
          dispatch('getTableData');
        }
      }
      return response;
    },
    async updateConditionReport({commit, state}, conditionReport) {
      let response = await ConditionReportsService.updateConditionReport(conditionReport.get('uuid'), conditionReport, 'created_by,released_by');
      if (response.success && state.modal.source === SOURCE_CONDITION_REPORTS_TABLE) {
        commit('updateConditionReport', response.body);
      }
      return response;
    },
    async updateConditionReportPartially({commit, state}, conditionReport) {
      let response = await ConditionReportsService.updateConditionReportPartially(conditionReport.uuid, conditionReport, ''); // TODO Adjust expand
      if (response.success && state.modal.source === SOURCE_CONDITION_REPORTS_TABLE) {
        commit('updateConditionReport', response.body);
      }
      return response;
    },
    async removeConditionReport({dispatch}, bidder) {
      let response = await ConditionReportsService.removeConditionReport(bidder.uuid);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: (state) => state.modal.show = false,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateExtraFilters: (state, extraFilters) => state.tableData[state.tableSource].extraFilters = extraFilters,
    updateConditionReport: (state, report) => {
      const index = state.tableData[state.tableSource].rows.findIndex(i => i.uuid === report.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...report};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
  }
}
